import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-recap',
  styleUrls: ['./recap.component.scss'],
  templateUrl: './recap.component.html'
})
export class RecapComponent implements OnChanges {
  @Input() public days: any;
  @Input() public serviceIcons: any;
  @Input() public version: any;
  @Input() public noImageUrl: any;
  @Input() public defaultImages: any = {};

  public getServiceIconPath(name: string): string | undefined {
    return this.serviceIcons ? this.serviceIcons[name] : undefined;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.days && changes.days.currentValue) {
      this.updateDays();
    }
  }

  updateDays(): void {
    const updatedDays = JSON.parse(JSON.stringify(this.days));

    // Phase 1: Expand services across date ranges
    updatedDays.forEach((day: any) => {
      if (day.hotels) {
        day.hotels.forEach((hotel: any) => {
          const checkinDate = new Date(hotel.checkin);
          const checkoutDate = new Date(hotel.checkout);

          for (let d = new Date(checkinDate); d < checkoutDate; d.setDate(d.getDate() + 1)) {
            const formattedDate = d.toISOString().split('T')[0];
            const existingDay = updatedDays.find((d: any) => d.date === formattedDate);

            if (existingDay && existingDay !== day) {
              if (!existingDay.hotels) {
                existingDay.hotels = [];
              }
              if (!existingDay.hotels.includes(hotel)) {
                existingDay.hotels.push(hotel);
              }
            }
          }
        });
      }
      if (day.cars) {
        day.cars.forEach((car: any) => {
          const checkinDate = new Date(car.pickup.date);
          const checkoutDate = new Date(car.dropoff.date);

          for (let d = new Date(checkinDate); d <= checkoutDate; d.setDate(d.getDate() + 1)) {
            const formattedDate = d.toISOString().split('T')[0];
            const existingDay = updatedDays.find((d: any) => d.date === formattedDate);

            if (existingDay && existingDay !== day) {
              if (!existingDay.cars) {
                existingDay.cars = [];
              }
              if (!existingDay.cars.includes(car)) {
                existingDay.cars.push(car);
              }
            }
          }
        });
      }

      if (day.escorteds) {
        day.escorteds.forEach((escorted: any) => {
          // Validazione: verifica che la struttura dati sia corretta
          if (!escorted.optionals?.[0]?.steps?.length) {
            return;
          }

          const checkinDate = new Date(escorted.optionals[0].steps[0].dateFrom);
          const checkoutDate = new Date(escorted.optionals[0].steps[escorted.optionals[0].steps.length - 1].dateTo);

          // Clona UNA VOLTA l'escorted base fuori dal loop (ottimizzazione memoria)
          const escortedBaseClone = JSON.parse(JSON.stringify(escorted));

          for (let d = new Date(checkinDate); d <= checkoutDate; d.setDate(d.getDate() + 1)) {
            const formattedDate = d.toISOString().split('T')[0];
            const existingDay = updatedDays.find((d: any) => d.date === formattedDate);

            if (existingDay && existingDay !== day) {
              if (!existingDay.escorteds) {
                existingDay.escorteds = [];
              }

              // Controllo duplicati: evita di aggiungere lo stesso escorted più volte
              const alreadyExists = existingDay.escorteds.some((e: any) => 
                e.sequenceNumber === escorted.sequenceNumber
              );
              
              if (alreadyExists) {
                continue;
              }

              // Clone leggero per questo giorno specifico (non deep clone completo)
              const escortedForDay = {
                ...escortedBaseClone,
                optionals: escortedBaseClone.optionals.map((opt: any) => {
                  const optCopy = { ...opt };
                  
                  if (optCopy.steps) {
                    const currentStep = optCopy.steps.find((step: any) => {
                      const stepDateFrom = new Date(step.dateFrom);
                      const stepDateTo = new Date(step.dateTo);
                      return d.getTime() >= stepDateFrom.getTime() && d.getTime() <= stepDateTo.getTime();
                    });

                    if (currentStep && currentStep.cityName) {
                      optCopy.city_name = currentStep.cityName;
                    }
                  }
                  
                  return optCopy;
                })
              };

              existingDay.escorteds.push(escortedForDay);
            }
          }
        });
      }
    });

    // Phase 2: Sort each day's service arrays chronologically
    updatedDays.forEach((day: any) => {
      if (Array.isArray(day.flights) && day.flights.length > 0) {
        day.flights.sort((a: any, b: any) =>
          (a.segments?.[0]?.departure?.hour ?? '99:99').localeCompare(b.segments?.[0]?.departure?.hour ?? '99:99')
        );
      }
      if (Array.isArray(day.cars) && day.cars.length > 0) {
        day.cars.sort((a: any, b: any) =>
          (a.pickup?.hour ?? '99:99').localeCompare(b.pickup?.hour ?? '99:99')
        );
      }
      if (Array.isArray(day.hotels) && day.hotels.length > 0) {
        day.hotels.sort((a: any, b: any) =>
          (a.serviceHour ?? '99:99').localeCompare(b.serviceHour ?? '99:99')
        );
      }
      if (Array.isArray(day.transfers) && day.transfers.length > 0) {
        day.transfers.sort((a: any, b: any) =>
          (a.optionals?.[0]?.serviceHour ?? '99:99').localeCompare(b.optionals?.[0]?.serviceHour ?? '99:99')
        );
      }
      if (Array.isArray(day.optionals) && day.optionals.length > 0) {
        day.optionals.sort((a: any, b: any) =>
          (a.optionals?.[0]?.serviceHour ?? '99:99').localeCompare(b.optionals?.[0]?.serviceHour ?? '99:99')
        );
      }
    });

    // Phase 3: Handle cityBefore services (must come AFTER sort)
    updatedDays.forEach((day: any) => {
      const dayCityName = day.city_name?.trim().toLowerCase();

      // Transfers with explicit cityBefore
      if (day.transfers) {
        const cityBeforeTransfers = day.transfers.filter((t: any) =>
          t.optionals && t.optionals.some((opt: any) => opt.cityBefore)
        );
        const normalTransfers = day.transfers.filter((t: any) =>
          !(t.optionals && t.optionals.some((opt: any) => opt.cityBefore))
        );

        if (cityBeforeTransfers.length > 0) {
          day.cityBeforeTransfer = cityBeforeTransfers[0];
          const optionRequestingCity = cityBeforeTransfers[0].optionals.find((opt: any) => opt.cityBefore);
          if (optionRequestingCity) {
            day.transferCity = optionRequestingCity.cityBefore;
          }
        }
        day.transfers = normalTransfers;
      }

      // Optionals whose city differs from the day's city
      if (day.optionals) {
        const cityBeforeOptionals: any[] = [];
        const normalOptionals: any[] = [];

        day.optionals.forEach((optionalGroup: any) => {
          const hasDifferentCity = optionalGroup.optionals?.some((opt: any) =>
            opt.city_name && dayCityName && opt.city_name.trim().toLowerCase() !== dayCityName
          );

          if (hasDifferentCity) {
            cityBeforeOptionals.push(optionalGroup);

            const firstDifferent = optionalGroup.optionals.find((opt: any) =>
              opt.city_name && dayCityName && opt.city_name.trim().toLowerCase() !== dayCityName
            );
            if (firstDifferent && !day.transferCity) {
              day.transferCity = firstDifferent.city_name;
            }
          } else {
            normalOptionals.push(optionalGroup);
          }
        });

        day.optionals = normalOptionals;
        if (cityBeforeOptionals.length > 0) {
          day.cityBeforeOptionals = cityBeforeOptionals;
        }
      }
    });

    // Phase 4: Build serviceOrder for sorted rendering in template
    updatedDays.forEach((day: any) => {
      const typeEntries: { type: string; index: number; key: string }[] = [];

      if (Array.isArray(day.flights) && day.flights.length > 0) {
        day.flights.forEach((f: any, idx: number) => {
          typeEntries.push({ type: 'flight', index: idx, key: this.getServiceSortKey('flight', f) });
        });
      }
      if (Array.isArray(day.cars) && day.cars.length > 0) {
        day.cars.forEach((c: any, idx: number) => {
          typeEntries.push({ type: 'vehicle', index: idx, key: this.getServiceSortKey('vehicle', c) });
        });
      }
      if (Array.isArray(day.transfers) && day.transfers.length > 0) {
        day.transfers.forEach((t: any, idx: number) => {
          typeEntries.push({ type: 'transfer', index: idx, key: this.getServiceSortKey('transfer', t) });
        });
      }
      if (Array.isArray(day.hotels) && day.hotels.length > 0) {
        day.hotels.forEach((h: any, idx: number) => {
          typeEntries.push({ type: 'hotel', index: idx, key: this.getServiceSortKey('hotel', h) });
        });
      }
      if (Array.isArray(day.optionals) && day.optionals.length > 0) {
        day.optionals.forEach((o: any, idx: number) => {
          typeEntries.push({ type: 'optional', index: idx, key: this.getServiceSortKey('optional', o) });
        });
      }

      typeEntries.sort((a, b) => a.key.localeCompare(b.key));
      day.serviceOrder = typeEntries.map(e => ({ type: e.type, index: e.index }));

      // Order cityBefore services together at the top
      const cityBeforeEntries: { type: string; index: number; key: string }[] = [];
      if (day.cityBeforeTransfer) {
        cityBeforeEntries.push({ type: 'transfer', index: 0, key: this.getServiceSortKey('transfer', day.cityBeforeTransfer) });
      }
      if (Array.isArray(day.cityBeforeOptionals) && day.cityBeforeOptionals.length > 0) {
        day.cityBeforeOptionals.forEach((o: any, idx: number) => {
          cityBeforeEntries.push({ type: 'optional', index: idx, key: this.getServiceSortKey('optional', o) });
        });
      }
      cityBeforeEntries.sort((a, b) => a.key.localeCompare(b.key));
      day.cityBeforeServiceOrder = cityBeforeEntries.map(e => ({ type: e.type, index: e.index }));
    });

    this.days = updatedDays;
  }

  private getServiceSortKey(type: string, service: any): string {
    switch (type) {
      case 'flight':
        return service?.segments?.[0]?.departure?.hour ?? '99:99';
      case 'vehicle':
        return service?.pickup?.hour ?? '99:99';
      case 'hotel':
        return service?.serviceHour ?? '99:99';
      case 'transfer':
      case 'optional':
        return service?.optionals?.[0]?.serviceHour ?? '99:99';
      default:
        return '99:99';
    }
  }

  public getSingleServiceDay(day: any, type: string, idx: number, isCityBefore = false): any {
    switch (type) {
      case 'flight':
        return { ...day, flights: [day.flights[idx]] };
      case 'vehicle':
        return { ...day, cars: [day.cars[idx]] };
      case 'transfer':
        if (isCityBefore) {
          return { ...day, transfers: [day.cityBeforeTransfer], transfersSuggested: [] };
        }
        return { ...day, transfers: [day.transfers[idx]] };
      case 'hotel':
        return { ...day, hotels: [day.hotels[idx]] };
      case 'optional':
        if (isCityBefore) {
          return { ...day, optionals: [day.cityBeforeOptionals[idx]] };
        }
        return { ...day, optionals: [day.optionals[idx]] };
      default:
        return day;
    }
  }

  public isCityAlreadyShownInEscorted(day: any): boolean {
    if (!day?.city_name || !day?.escorteds?.length) {
      return false;
    }

    const targetCity = day.city_name.trim().toLowerCase();
    const firstEscorted = day.escorteds[0];

    if (!firstEscorted?.optionals) {
      return false;
    }

    return firstEscorted.optionals.some((opt: any) =>
      opt.city_name && opt.city_name.trim().toLowerCase() === targetCity
    );
  }
}
